import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Link(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M7.152 24a7.102 7.102 0 01-5.057-2.095A7.103 7.103 0 010 16.848c0-1.912.744-3.708 2.095-5.058l1.615-1.616a1.44 1.44 0 112.037 2.036l-1.616 1.616a4.245 4.245 0 00-1.25 3.022c0 1.141.443 2.213 1.25 3.02a4.243 4.243 0 003.021 1.252 4.243 4.243 0 003.022-1.252l2.424-2.423a4.279 4.279 0 000-6.042 1.438 1.438 0 010-2.036 1.438 1.438 0 012.036 0c2.788 2.788 2.788 7.325 0 10.114l-2.424 2.424A7.102 7.102 0 017.152 24zm3.232-8.945c-.368 0-.737-.14-1.018-.422-2.788-2.788-2.788-7.325 0-10.115l2.424-2.423A7.104 7.104 0 0116.848 0c1.91 0 3.707.744 5.057 2.095A7.102 7.102 0 0124 7.152a7.104 7.104 0 01-2.095 5.058l-1.615 1.616a1.44 1.44 0 01-2.037-2.036l1.616-1.617a4.242 4.242 0 001.25-3.02 4.244 4.244 0 00-1.25-3.022 4.244 4.244 0 00-3.021-1.25 4.242 4.242 0 00-3.021 1.25l-2.425 2.424a4.279 4.279 0 000 6.042 1.438 1.438 0 01-1.018 2.458z"
  }));
}

export { Link };
//# sourceMappingURL=Link.js.map